import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
import { Link } from 'react-router-dom';
import Customericon from '../../assets/icons8-manager-64.png';
import Editicon from '../../assets/icons8-edit-new-64.png';
import Deleteicon from '../../assets/icons8-trash-50.png';
import { get, patch, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import DialogBox from '../DialogBox';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Button from '@mui/material/Button';
import { Switch } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_list: [],
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 15,
            success: false,
            error: false,
            warning: false,
            error1: false,
            success2: false,
            confirmDialog: {
                isOpen: false,
                title: '',
                subtitle: '',
            },
            user_id:'',
            editToggle: false,
            first_name: "",
            last_name: "",
            phone_no: "",
            email: "",
            is_active: true,
            open_progress_bar: false,
            loading: true,
            groups_list: [],
            groupname : ''
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.validateSignedIn();
          }, 0);
        this.getUsersList();
        // this.getGroupsList(); //uncomment this for group feature in edit user group.
    }

    validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);
      
          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.success !== prevState.success ||
            this.state.success2 !== prevState.success2
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.error1 ||
                this.state.success ||
                this.state.success2
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        error1: false,
                        success2: false,
                        success: false,
                    });
                }, 3000); // 1 second
            }
        }
    }

    getGroupsList = async () => {
        try {
        this.startLoading();
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        console.log("--------auth tocken getGroupsList---------", access_tocken);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
        }
    
        console.log("Fetching data from:", urls.GET_ALL_GROUPS); // Update URL for fetching sites
        const response = await get(urls.GET_ALL_GROUPS, headers);
        console.log("response getGroupsList ===> ", response);
        this.stopLoading();
        if (!response.data.groups) {
            console.error("Failed to fetch getGroupsList.");
            this.setState({ groups_list: [] });
            return;
        }
    
        this.setState({ groups_list: response.data.groups});
        } catch (error) {
        console.error("Error in getGroupsList:", error);
        this.setState({ groups_list: [] });
        }
    };

    getUsersList = async () => {
        console.log("Fetching data from:", urls.GET_USERS);
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let dealer_id= localStorage.getItem(globalVariables.USER_ID);
            console.log("--------dealer_id---------", dealer_id);
            console.log("--------auth token---------", access_token);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            }
           let url = urls.GET_USERS_UNDER_ADMIN(dealer_id);
           console.log("--------url---------", url);
            const response = await get(urls.GET_USERS_UNDER_ADMIN(dealer_id), headers); // API call
            console.log("--------response--getUsersList-------", response);
            this.setState({ loading: false });
            // Validate the response and extract results
            if (response.error.length > 0) {
                console.error("Invalid response or results:", response);
                this.setState({ user_list: [] });
                return;
            }
            this.setState({ user_list: response.data });
            console.log("user_list---------", this.state.user_list);
        } catch (error) {
            console.error("Error in getUsersList:", error);
            this.setState({ user_list: [], loading: false, });
        }
    };

    handleDelete = async (email) => {
        // const userConfirmed = window.confirm('Are you sure you want to delete this user?');
        // if (!userConfirmed) return;
        let dealer_id= localStorage.getItem(globalVariables.USER_ID);

        try {
            this.startLoading();
            console.log("emailll,",email);
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("urls.DELETE_USER(dealer_id) ",urls.DELETE_USER(dealer_id));
            const requestBody = JSON.stringify({ email }); // Wrap email in an object
            console.log("Request body:", requestBody);
            const response = await fetch(urls.DELETE_USER(dealer_id), {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_tocken}`,
                },
                body: requestBody,
            });
            this.stopLoading();
            console.log("responsee",response);
            if (!response.ok) throw new Error(`Error: ${response.status}`);
                setTimeout(() => {
                    // window.location.reload();
                    this.getUsersList()
                }, 2000);
                this.setState({ selectedBlocks: [], success: true });
            
        } catch (error) {
            console.error('Error deleting user:', error);
            // alert('Failed to delete client. Please try again.');
            this.setState({ error: true });
        }
    };

    // handleEdit = (user_id) => {
    //     this.props.navigate(`/edit-client/${user_id}`);
    // };

    handleEdit = async (user_id) => {
        this.setState({ editToggle: true, user_id: user_id });
        try {
            this.startLoading();
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.USER_DETAILS(user_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL
            this.stopLoading();
            console.log(`API Response for LoadSelectedUserInfo ${user_id}:`, response);
            let data = response.data

            if (data && Object.keys(data).length > 0) {
                console.log(`API Response for LoadSelectedDeviceInfo ${user_id}:`, data);
                this.setState({
                    first_name: data.first_name || "",
                    last_name: data.last_name || "",
                    email: data.email || "",
                    phone_no: data.phoneno || "",
                    is_active: data.is_active,
                });

            } else {
                console.error("No valid data returned from the get-camera API");
                // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    };

    handleEditSave = async () => {
        this.startLoading();
        let { first_name, last_name, email, phone_no, is_active } = this.state;
        let data = JSON.stringify({
            first_name,
            last_name,
            email,
            "phoneno": phone_no,
            is_active
        });
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        // console.log("--------auth tocken---------", access_tocken);
        let headers = {
            // 'content-type': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${access_tocken}`
        }

        let response = await patch(urls.UPDATE_USER_DEATILS(this.state.user_id), data, headers)
        console.log("response ==>", response)
        this.stopLoading();
        if (response && response.detail === "User updated successfully.") {
            // alert("Site updated successfully.");
            this.setState({ 
                success2: true 
            })
            setTimeout(() => {
                // window.location.reload();
                this.setState({ 
                    editToggle: false,
                    });
                this.getUsersList();
            }, 2000);
        } else {
            // alert("Error updating site. Please try again.");
            this.setState({ 
                error2: true 
            })
        }
    }

    closePopup = () => {
        this.setState({ editToggle: false });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleChangePage = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value });
      };

    openDialog = (onConfirm) => {
    this.setState({
        confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to delete this User?",
        onConfirm
        },
    });
    };

    closeDialog = () => {
        this.setState({
          confirmDialog: {
            ...this.state.confirmDialog,
            isOpen: false,
          },
        });
      };

    handleToggle = (is_active) => {
             this.setState((prevState) => ({
                is_active: !prevState.is_active, // Toggle the current state
            }));
            console.log("Toggled is_active to:", !this.state.is_active);
    };

    startLoading = () => {
        console.log("startloading")
    
        this.setState({ open_progress_bar: true })
    };
      
    stopLoading = () => {
          this.setState({ open_progress_bar: false })
    };
      
    render() {
        const { user_list, currentPage, rowsPerPage, searchInput ,confirmDialog , success, error, error1, success2, warning,
            editToggle, first_name, last_name, email, phone_no, is_active, loading, groups_list, groupname} = this.state;

        // Filter user list based on search input
        // const filteredClientList = user_list.filter((user) =>
        //     (user.first_name && user.first_name.toLowerCase().includes(searchInput.toLowerCase())) ||
        //     (user.address && user.address.toLowerCase().includes(searchInput.toLowerCase()))
        // );
        
        // Filter devices based on search input
        const filteredUserList = user_list.filter((user) =>
        user.username.toLowerCase().includes(searchInput.toLowerCase())
        );

        // Calculate pagination indices
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredUserList.slice(indexOfFirstRow, indexOfLastRow);

        if (loading) return <p style={{marginLeft:'1cm'}}>Loading...</p>;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow:'none' }}>
                <>
                <div className="home-container" style={{ display: 'flex', flex: '1', overflow: 'hidden', paddingLeft: '5px' }}>
                    <div style={{ flex: '5', marginLeft:'2%', padding: '20px' }}>
                    {warning ? (
                    <Alert severity="warning">Please fill all the required fields.</Alert>
                    ) : error ? (
                        <Alert severity="error">Server Error! User was not deleted!</Alert>
                    ) : success ? (
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                            "User Deleted successful."
                        </Alert>
                    ) : null}
                        <div>
                            <div className="search-container">
                            <span>
                                {/* <span style={{border: '1px solid gray', width:'25%', padding:'5px'}}> */}
                                {/* <button style={{backgroundColor:'#5b83ae', color:'white'}}> Excel </button>&nbsp; <button style={{backgroundColor:'#5b83ae', color:'white'}}> PDF </button> */}
                                </span>
                                <input
                                type="text"
                                id="search-input"
                                placeholder="Search by user name"
                                value={searchInput}
                                onChange={this.handleSearchInputChange}
                                />
                            </div>
                            <div className="grid-container-user" style={{ marginTop: '6px' }}>
                            { currentRows.length > 0 ?
                            currentRows.map((user) => (
                                <div key={user.user_id} className="client-card">
                                    <span style={{ display: 'flex', justifyContent: 'right', alignItems:'center' }}>
                                            <Link>
                                                <img
                                                    width="25"
                                                    height="30"
                                                    src={Editicon}
                                                    id="edit_icon"
                                                    alt="editIcon"
                                                    title='Edit User Info'
                                                    onClick={() => this.handleEdit(user.user_id)}
                                                />
                                            </Link>&ensp;
                                            <Link>
                                                <img
                                                    width="20"
                                                    height="18"
                                                    src={Deleteicon}
                                                    id="delete_icon"
                                                    alt="delIcon"
                                                    title='Delete User'
                                                    onClick={() => this.openDialog(() =>this.handleDelete(user.email))}
                                                />
                                            </Link>
                                    </span>
                                    <div style={{display:'flex', alignItems:'baseline', height:'45px'}}>
                                    <img width="26" height="26" src={Customericon} alt="engineer" />&nbsp;<h3>{user.username || 'N/A'}</h3>
                                    </div>
                                    <p>Address: {user.address || 'N/A'}</p>
                                    <p>Phone no.: {user.phoneno || 'N/A'}</p>
                                </div>
                            ))
                            :(
                                <p style={{color:'orange'}}>No user is registered.</p>
                            )}

                            </div>
                            <div style={{ marginTop: '2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                <Button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    {"< Prev"}
                                </Button>&emsp;
                                <span style={{ fontSize: 'small' }}>
                                    {`Page ${currentPage} / ${Math.ceil(filteredUserList.length / rowsPerPage)}`}
                                </span>&emsp;
                                <Button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage + 1)}
                                    disabled={currentPage === Math.ceil(filteredUserList.length / rowsPerPage)}
                                >
                                    {"Next >"}
                                </Button>
                            </div>
                            
                        </div>
                    </div>
                </div>
                {editToggle && (
                            <div style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                                zIndex: 999, 
                                display: "flex",
                                justifyContent: "flex-end", 
                                alignItems: "center", // Align vertically
                                        }}
                                    >
                                    
                                    <div className='Slide-device-Add-form'>
                                        {/* Close icon */}
                                        <button
                                            onClick={this.closePopup}
                                            style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            background: "transparent",
                                            border: "none",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            }}
                                        >
                                        ✖
                                        </button>
                                        <div className="form-section">
                                            <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#003366', height: '1cm', alignContent: 'center' }}>Edit User Info</h3>

                                            {error1 ? (
                                                <Alert severity="error">Server Error! User info was not edited!</Alert>
                                            ) : success2 ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success"> User info was edited successfully!</Alert>
                                            ) : null}
                                                                                        
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="sitename">
                                                    First Name : &nbsp;
                                                </label>
                                                <input
                                                    type="text"
                                                    name="first_name"
                                                    value={first_name || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />
                                            </div>
  
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="organisation_name">
                                                    Last Name: &nbsp;
                                                </label>
                                                <input
                                                    type="text"
                                                    name="last_name"
                                                    value={last_name || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />
                                            </div>
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="timezone">
                                                    Phone no. : &nbsp;
                                                </label>

                                                <input
                                                    type="text"
                                                    name="phone_no"
                                                    value={phone_no || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />

                                            </div>
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="timezone">
                                                    Email : &nbsp;
                                                </label>

                                                <input
                                                    type="text"
                                                    name="email"
                                                    value={email || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />

                                            </div>
                                            {/* uncomment below div for group feature */}
                                            {/* <div className='form-group-device-edit'>
                                                <label htmlFor="last_name">
                                                    Group name : &nbsp;
                                                </label>
                                                <select
                                                        name="groupname"
                                                        value={groupname}
                                                        onChange={(evt) => this.setState({ groupname: evt.target.value })}
                                                        style={{ width: '365px', height: '1cm', fontFamily: "Arial, sans-serif", fontSize:'13px', color:'black' }}
                                                    >
                                                        <option value="" disabled >Select group for this user</option>
                                                        {groups_list.map((type) => (
                                                            <option key={type.id} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div> */}
                                            <div style={{ display: "flex", marginLeft:'7.5%', gap: "80px", color:"#001668" }}>
                                                <label htmlFor="timezone">
                                                    Is Active? : &nbsp;
                                                </label>
                                                <Switch
                                                    checked={is_active}
                                                    onChange={() => this.handleToggle(is_active)}
                                                    name="is_active"
                                                    color="primary"
                                                    size="small"
                                                    style={{marginRight:'18%' }}
                                                />
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "right", gap: "5px" }}>
                                                <Button
                                                    type="button"
                                                    onClick={this.handleEditSave}
                                                    style={{
                                                        width: "0.8cm",
                                                        height: "0.7cm",
                                                        // backgroundColor: "#326388",
                                                        // color: "white",
                                                    }}
                                                    id='rowsPerPageButton'
                                                >
                                                    Save
                                                </Button>
                                                <Button
                                                    type="button"
                                                    onClick={this.closePopup}
                                                    style={{
                                                        width: "0.8cm",
                                                        height: "0.7cm",
                                                        backgroundColor: "#e02e2e",
                                                        color: "white",
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    )}
                <DialogBox
                    confirmDialog={confirmDialog}
                    setConfirmDialog={(updatedDialog) =>
                        this.setState({ confirmDialog: updatedDialog })
                    }
                    onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                    onCancel={this.closeDialog}
                />
                </>
                {/* Backdrop with Circular Progress */}
                <Backdrop open={this.state.open_progress_bar} style={{zIndex:'1000'}}>
                        <div className="custom-spinner">
                            <div className="circle"></div>
                            <div className="circle tilted"></div>
                            <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                        </div>
                </Backdrop>
            </div>
        );
    }
}

export default withNavigate(UserList);
